// pages/ResetPassword.jsx
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/css/Login.css';

export default function ResetPassword() {
  const [new_password, setNewPassword] = useState('');
  const [new_password_confirmation, setNewPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const { email, token } = useParams();

  useEffect(() => {
    if (!email || !token) {
      setError('Invalid reset link. Please check your email and try again.');
      return;
    }
  }, [email, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (new_password !== new_password_confirmation) {
      setError('Passwords do not match');
      toast.error('Passwords do not match');
      return;
    }

    if (new_password.length < 6) {
      setError('Password must be at least 6 characters long');
      toast.error('Password must be at least 6 characters long');
      return;
    }
    
    try {
      setError('');
      setLoading(true);
      const result = await resetPassword(token, decodeURIComponent(email), new_password, new_password_confirmation);
      
      if (result.success) {
        setSuccess(true);
        toast.success('Password reset successfully! Redirecting to login...', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        setTimeout(() => {
          navigate('/admin/login');
        }, 2000);

      } else {
        setError(result.message || 'Failed to reset password');
        toast.error(result.message || 'Failed to reset password');
      }
    } catch (err) {
      setError('Failed to reset password');
      toast.error('Failed to reset password');
    }
    
    setLoading(false);
  };

  if (success) {
    return (
      <>
        <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
          <Row className="w-100 justify-content-center">
            <Col md={4} sm={8} xs={12}>
              <Card className="shadow">
                <Card.Body className="p-5 text-center">
                  <h2 className="mb-4">Success!</h2>
                  <p className="text-muted">Your password has been reset. Redirecting to login...</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }

  return (
    <>
      <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
        <Row className="w-100 justify-content-center">
          <Col md={4} sm={8} xs={12}>
            <Card className="shadow">
              <Card.Body className="p-5">
                <h2 className="text-center mb-4">Passwort zurücksetzen</h2>
                <p className="text-center">Bitte geben Sie Ihr neues Passwort ein</p>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="hidden"
                      value={decodeURIComponent(email || '')}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="hidden"
                      value={token || ''}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formNewPassword">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type="password"
                      value={new_password}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                      minLength={6}
                      disabled={loading}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formNewPasswordConfirmation">
                    <Form.Label>Confirm New Password</Form.Label>
                    <Form.Control
                      type="password"
                      value={new_password_confirmation}
                      onChange={(e) => setNewPasswordConfirmation(e.target.value)}
                      required
                      minLength={6}
                      disabled={loading}
                    />
                  </Form.Group>
                  <Button
                    disabled={loading || !new_password || !new_password_confirmation}
                    className="w-100 login-btn"
                    variant="primary"
                    type="submit"
                  >
                    {loading ? 'Resetting Password...' : 'Reset Password'}
                  </Button>

                  <div className="text-start mt-3">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => navigate('/admin/login')}
                      disabled={loading}
                    >
                      ← Zurück zum Login
                    </button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}